import { useTranslation } from "react-i18next";
import { DocumentCategory } from "../../autogen/bff-api";

export const useDocumentCategoryLabel = () => {
  const { t } = useTranslation();
  return (category: DocumentCategory): string => {
    switch (category) {
      case DocumentCategory.CompetitionBasis:
        return t("documentCategory.COMPETITION_BASIS");
      case DocumentCategory.PriceSheet:
        return t("documentCategory.PRICE_SHEET");
      case DocumentCategory.RequirementsSpec:
        return t("documentCategory.REQUIREMENTS_SPEC");
      case DocumentCategory.Contract:
        return t("documentCategory.CONTRACT");
      case DocumentCategory.Other:
        return t("documentCategory.OTHER");
    }
  };
};

export const DOCUMENT_CATEGORY_ORDER: DocumentCategory[] = [
  DocumentCategory.CompetitionBasis,
  DocumentCategory.RequirementsSpec,
  DocumentCategory.PriceSheet,
  DocumentCategory.Contract,
  DocumentCategory.Other,
];
